import React from 'react';
import { Link } from 'react-router-dom';
import AppConstants from '../../../appConstants';

/**
 * Final step of the "Be a Matchmaker" flow — confirmation after submit.
 * No dedicated Figma frame; copy mirrors the "Email to Referring Person" (20:413)
 * and layout reuses the "Your Details" page tokens.
 */
const MatchmakerSuccessComponent = ({ values, onRecommendAnother }) => (
  <div className="matchmakerWrapper mm-success">
    <div className="mm-content mm-content-form">
      <h1 className="mm-title mm-title-tight">
        Thank you for becoming a Lovrican Matchmaker!
      </h1>
      <p className="mm-lead">
        We’ve received your recommendation and will be reaching out to{' '}
        {values.firstName} soon. If they choose to join Lovrican, our team will
        guide them through the process and introduce them to compatible matches.
      </p>
      <div className="mm-success-actions">
        <button
          type="button"
          className="mm-btn mm-btn-primary"
          onClick={onRecommendAnother}
        >
          Recommend someone else
        </button>
        <Link className="mm-btn mm-btn-ghost" to={AppConstants.routes.home}>
          Back to home
        </Link>
      </div>
    </div>
  </div>
);

export default MatchmakerSuccessComponent;
